import { configureStore } from "@reduxjs/toolkit";
import { apiCollection } from "./api/apiCollection";
import authReducer from "./features/authSlice";
import navReducer from "./features/navSlice";

export const store = configureStore({
  reducer: {
    [apiCollection.reducerPath]: apiCollection.reducer,
    nav: navReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      apiCollection.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
